/** 页面信息 */
const page = new (function () {
  this.title = '修正案件区划'
  this.icon = 'iconfont iconicon_group'
  this.name = 'punish_correct_case_area'
  /**菜单编号 */
  this.code = 'punish_correct_case_area'
  /**菜单别名 */
  this.aliasName = 'punish_correct_case_area'
  /**路由地址 */
  this.path = '/correct/caseArea'
  //**接口权限 */
  this.permissions = []
})()

/** 路由信息 */
export const route = {
  page,
  component: () => import('./index.vue')
}

export default page
